import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { InvoiceService } from '../../service/data/invoice.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Invoice } from '../../model/invoice';
import { GetReminderDeliveryMethodIcon, ReminderDeliveryMethod, ReminderDeliveryMethodToString } from '../../model/const/enum';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ProfileService } from '../../../common/service/data/profile.service';
import { NativeWindowService } from '../../../core/service/native-window.service';

@Component({
    selector: 'app-deliver-invoice-reminder',
    templateUrl: './deliver-invoice-reminder.component.html',
    styleUrls: ['./deliver-invoice-reminder.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeliverInvoiceReminderComponent implements OnInit, OnDestroy {
  constructor(
    private _dataService: InvoiceService,
    private _modalService: ActionWindowService,
    cf: FormControlExFactory,
    private _profileService: ProfileService,
    private _nativeWindow: NativeWindowService,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      deliveryMethod: cf.createMandatory('INVOICE.DELIVERY_METHOD', ReminderDeliveryMethod.Mail),
      invoiceRecipientEmail: cf.create('COMMON.EMAIL_ADDRESS', null),
      sendToGuarantor: cf.create('INVOICE.SEND_TO_GUARANTOR', true),
      id: cf.createHidden(''),
    });
  }

  private sub: Subscription;
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  private _dataContext: {
    invoices?: Invoice[];
  };

  get dataContext(): {
    invoices?: Invoice[];
  } {
    return this._dataContext;
  }
  set dataContext(value: { invoices?: Invoice[] }) {
    this._dataContext = value;
    if (value.invoices instanceof Array) {
      if (this.dataContext.invoices && this.dataContext.invoices.length == 1) {
        this.invoice = this.dataContext.invoices[0];
        this.form.controls['id'].setValue(this.invoice.id);
        this.form.controls['deliveryMethod'].setValue(ReminderDeliveryMethod.Email);
        this.form.controls['invoiceRecipientEmail'].setValue(this.invoice.invoiceRecipientEmail);
      }
    }
  }
  readonly form: FormGroup;
  deliveryMethods = [
    { name: ReminderDeliveryMethodToString(ReminderDeliveryMethod.Mail), value: ReminderDeliveryMethod.Mail, icon: GetReminderDeliveryMethodIcon(ReminderDeliveryMethod.Mail) },
    { name: ReminderDeliveryMethodToString(ReminderDeliveryMethod.Email), value: ReminderDeliveryMethod.Email, icon: GetReminderDeliveryMethodIcon(ReminderDeliveryMethod.Email) },
    { name: ReminderDeliveryMethodToString(ReminderDeliveryMethod.Manual), value: ReminderDeliveryMethod.Manual, icon: GetReminderDeliveryMethodIcon(ReminderDeliveryMethod.Manual) },
  ];

  invoice: Invoice;

  get mailDeliveryAddress(): string {
    if (this.invoice.debtor.address)
      return (
        this.invoice.debtor.address.name +
        ', ' +
        this.invoice.debtor.address.street +
        ', ' +
        this.invoice.debtor.address.postalCode +
        ' ' +
        this.invoice.debtor.address.city
      );
    else return '';
  }

  get isDeliveryMethodEmail(): boolean {
    if (this.form.controls['deliveryMethod'].value)
      return (
        this.form.controls['deliveryMethod'].value === ReminderDeliveryMethod.Email ||
        this.form.controls['deliveryMethod'].value === ReminderDeliveryMethod.Email
      );
    else return false;
  }

  get isDeliveryMethodMail(): boolean {
    if (this.form.controls['deliveryMethod'].value) return this.form.controls['deliveryMethod'].value === ReminderDeliveryMethod.Mail;
    else return false;
  }

  get isDeliveryMethodManual(): boolean {
    if (this.form.controls['deliveryMethod'].value) return this.form.controls['deliveryMethod'].value === ReminderDeliveryMethod.Manual;
    else return false;
  }

  cancel() {
    this._modalService.close();
  }

  ngOnInit() {}

  onSubmit() {
    if (this.form.invalid) return;

    this.form.disable();

    if (this.sub) {
      this.sub.unsubscribe();
    }

    if (this.invoice) {
      if (this.isDeliveryMethodManual) {
        const tab = this._nativeWindow.openTab();
        this.sub = this._dataService
          .createReminder(this.form.value)
          .pipe(
            switchMap(reminderResponse => {
              return this._dataService.getLatestReminderPdfForInvoice(this.invoice.id);
            })
          )
          .subscribe(
            (pdfBlob: Blob) => {
              this._nativeWindow.openFile(pdfBlob, `Paminnelse_${this.invoice.invoiceNumber}.pdf`, tab);
              this._modalService.complete({ message: 'Påminnelse skapad och PDF öppnad för utskrift' });
              this._modalService.close();
            },
            error => {
              console.error('Fel vid skapande av påminnelse eller hämtning av PDF:', error);
              this.form.enable();
            }
          );
      } else {
        this.sub = this._dataService.createReminder(this.form.value).subscribe(
          res => {
            this._modalService.complete(res);
            this._modalService.close();
          },
          error => this.form.enable()
        );
      }
      return;
    }
  }
}
